import MultiArgsFilter from './multi-args-filter/MultiArgsFilter';

export default class ButtonType extends MultiArgsFilter {
    constructor(element, parent) {
        super(element, parent);
        this.buttons = element.querySelectorAll('button');
        this.buttonGroup = element?.querySelector('.gravity-block-filters__button-group');
        this.type = this.buttonGroup?.dataset.type;

        if (this.type === 'taxonomy') {
            this.taxonomySlug = this.buttonGroup?.dataset.taxonomy;
        }
    }

    init() {
        if (!this.buttons) {
            return;
        }

        this.registerEvents();
        this.updateInitialValues();
    }

    get filterTaxonomySlug() {
        return this.taxonomySlug ?? '';
    }

    get filterType() {
        return this.type ?? '';
    }

    registerEvents() {
        [...this.buttons].forEach((button) => {
            button.addEventListener('keydown', (event) => {
                const keyCode = event.which.toString();

                // Enter or space key
                if (keyCode === '13' || keyCode === '32') {
                    event.preventDefault();

                    this.changeState(event);
                }
            });

            button.addEventListener('click', (event) => {
                event.stopPropagation();

                this.changeState(event);
            });
        });
    }

    changeState(event) {
        const changedItem = event.target;
        const isActive = changedItem.classList.contains('active');
        const { slug } = changedItem.dataset;

        changedItem.classList.toggle('active');

        this.updateFilterArgs(slug, isActive);

        if (!this.parent.hasApplyButton) {
            this.parent.sendFiltersChange(event.target);
        }
    }

    updateInitialValues() {
        // Check if exist filter args for this type
        if (!this.hasFilterArgs()) {
            return;
        }

        const selectedSlugs = this.getFilterArgs();

        [...this.buttons].forEach((item) => {
            if (selectedSlugs.includes(item.dataset.slug)) {
                item.classList.add('active');
            }
        });
    }

    clear() {
        [...this.element.querySelectorAll('button')].forEach((item) => item.classList.remove('active'));
    }
}
